import qs from 'qs'

const parse = (search: unknown): Record<string, string> => {
  if (typeof search !== 'string') return {}
  return qs.parse(search, { ignoreQueryPrefix: true }) as Record<string, string>
}
export default parse
